import * as React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Seo from "../components/seo"
import Hero from "../components/hero"
import Stats from "../components/stats"
import Features from "../components/features"
import Navigation from "../components/navigation"
import Navbar from "../components/navbar"
import Testimonial from "../components/testimonal"
import Cta from "../components/cta"
import Sponsors from "../components/sponsors"
import Impact from "../components/impact"
import Help from "../components/Help"
const IndexPage = () => (
  <>
    <Navbar />
    <Hero />
    <Sponsors />
    <Impact />
    <Stats />
    <Help />
    <Testimonial />
    <Cta />
    <Navigation />
  </>
)

export default IndexPage
